<template>
  <!-- 右边 -->
  <div class="login-box">
    <!-- return返回 -->
    <div class="return-box">
      <el-icon><ArrowLeft /></el-icon>
      返回
    </div>
    <p class="title-box1">扫码登录</p>
    <div class="QRCode-box"></div>
    <p class="title-box2">请使用微信扫一扫登录</p>
  </div>
</template>

<script setup>
import { ref, reactive } from "vue";
import { ElMessage } from "element-plus";
import { useRouter } from "vue-router";


// import newPasswordPhoneNumber from "@/views/login/components/newPasswordPhoneNumber/index.vue";
// import newPasswordEmail from "@/views/login/components/newPasswordEmail/index.vue";


const router = useRouter();

var mydata = reactive({
  // btnLoading: false,
  // zhanghao: "",
  // mima: "",
  // form: {
  //   username: "",
  //   password: "",
  // },
  // checked1: false,
  // activeName: "first",
});

// function handleClick(tab) {
//   console.log(tab);
// }

//按钮的事件函数
function submit() {
  // 跳转页面
  router.push({
    // path: "/layout/list/personalCenter",
    path: "/layout/list/personalCenter/personalInfor",
  });

  // console.log(mydata.zhanghao, mydata.mima);
  mydata.btnLoading = true;
  // axios({
  //   method: "post",
  //   url: "/house/login/login",
  //   data: {
  //     //请求参数（get请求的时候必须用params，post请求的时候必须用data）
  //     account: mydata.zhanghao,
  //     password: mydata.mima,
  //     // sourceText: mydata.zhanghao + mydata.mima, //sourceText就是这次项目的后端跟你说的必须用什么属性名，否则后端就拿不到了；属性值是我要传给后端的内容
  //   },
  // }).then((res) => {
  //   mydata.btnLoading = false;
  //   if (res.data.code === 1) {
  //     ElMessage({
  //       message: res.msg,
  //       type: "success",
  //     });

  //     // 存储后端返回的token值
  //     localStorage.setItem("token", res.data.data.token);
  //     localStorage.setItem("adminName", mydata.zhanghao);

  //     // 跳转页面
  //     router.push({
  //       path: "/layout/list/personalCenter/personalInfor/index.vue",
  //     });

  //     mydata.zhanghao = "";
  //     mydata.mima = "";
  //   }
  // });
}
</script>

<style scoped lang="scss">
//登录盒子
.login-box {
  width: 450px;
  height: 467px;
  background-color: #ffffff;
  // border: 1px solid rgb(255, 238, 0);
  border-radius: 8px;
  // padding: 0px 46px !important;

  ////////返回
  .return-box {
    margin: 0 auto;
    // border: 1px solid blue;
    margin: 20px 0px 10px 20px;
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    :deep(.el-icon) {
      font-size: 16px;
      font-weight: 700;
      margin-right: 5px;
    }
    p:hover {
      color: #009de0;
    }
  }
  
  ////////扫码登录
  .title-box1{
    font-size:20px;
    font-weight:400;
    color:#282828;
    text-align: center;
    margin-bottom:30px;

  }

  /////////二维码
  .QRCode-box{
     width:214px;
     height:214px;
     margin:0 auto;
     border:1px solid #CCCCCC;
  }

  ////////
  .title-box2{
    font-size:14px;
    font-weight:400;
    color:#333333;
    text-align: center;
    margin-top:10px;

  }
 
}




</style>
